const results = [
  'повышение самостоятельности сотрудников — команда принимает решения в рамках полномочий;',
  'снижение микроменеджмента — руководитель управляет результатом, а не каждым действием;',
  'более понятные задачи — сотрудники понимают, что и зачем делать;',
  'рост ответственности — сотрудники отвечают за результат, а не за процесс;',
  'улучшение командного взаимодействия — понятные роли и правила работы;',
  'повышение качества обратной связи — регулярная и конструктивная;',
  'более конструктивное решение конфликтов — проблемы обсуждаются раньше;',
  'развитие кадрового резерва — сильные специалисты растут в руководителей;',
  'повышение вовлечённости — сотрудники видят связь работы с результатом;',
  'снижение зависимости от отдельных сотрудников — знания распределены;',
  'более эффективное управление изменениями — команда быстрее адаптируется.',
];

export default function CompanyResults() {
  return (
    <section id="results" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Результаты развития управленческой команды
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Потенциальные изменения для компании, когда руководители системно применяют инструменты мотивации и управления командой. Мы не обещаем гарантированный рост конкретных показателей — результат зависит от внедрения
        </p>

        <div className="grid sm:grid-cols-2 gap-3 max-w-4xl mx-auto">
          {results.map((r, i) => (
            <div key={i} className="flex items-start gap-2.5 bg-white rounded-lg border border-gray-200 p-3 hover:border-teal-300 transition-colors">
              <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
              <span className="text-sm text-gray-700">{r}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}